/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
import { initializeFirebase } from "../../pushNotification";
import { isMobile } from "react-device-detect";

import { PushNotifications } from "@capacitor/push-notifications";
import { Toast } from "@capacitor/toast";
import { useAtom } from "jotai";
import {
  alertModal,
  appConstants,
  bell,
  notify,
  permaStatus,
} from "../../AtomStore/store";
import { getDeviceToken, setDeviceToken } from "../../AtomStore/ServiceAtoms";
import { useRequestProcessor } from "../../requestProcessor";
import { saveToken } from "../../QueryFunctions/queryfunction";

const showToast = async (msg) => {
  await Toast.show({
    text: msg,
  });
};

//Broswer agents
let userAgentString = navigator.userAgent;

const isChrome =
  !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
const isFirefox = typeof InstallTrigger !== "undefined";
// Detect Safari
let safariAgent = userAgentString.indexOf("Safari") > -1;

const NotificationService = () => {
  const [constants] = useAtom(appConstants);
  const [, setNotification] = useAtom(notify);
  const [, setModal] = useAtom(alertModal);
  const [, setShowBell] = useAtom(bell);
  const [permStatus, setPermStatus] = useAtom(permaStatus);
  const { useMutationWrapper } = useRequestProcessor();
  console.log("inside notificationm service");
  const saveTokenFn = useMutationWrapper("saveToken", (token) => {
    setPermStatus({ receive: "granted" });
    return saveToken(token);
  });

  console.log("Permission Status", permStatus);
  const getDeliveredNotifications = async () => {
    const notificationList =
      await PushNotifications.getDeliveredNotifications();
    console.log("delivered notifications", notificationList);
  };

  const registerMobileNotifications = async () => {
    let permStatus = await PushNotifications.checkPermissions();
    console.log("Check permissions: ", permStatus);

    if (permStatus.receive !== "granted") {
      permStatus = await PushNotifications.requestPermissions();
      if (permStatus.receive !== "granted") {
        setPermStatus({ receive: "denied" });
        showToast("Push Notification permission denied");
      } else {
        showToast("Push Notification permission granted");
        register();
      }
    } else {
      register();
    }
  };

  const register = async () => {
    console.log("Initializing HomePage");

    // Register with Apple / Google to receive push via APNS/FCM
    await PushNotifications.register();

    // On success, we should be able to receive notifications
    PushNotifications.addListener("registration", (token) => {
      console.log("token", token.value);
      setDeviceToken(token.value);
      saveTokenFn.mutate(token.value);
    });

    // Some issue with our setup and push will not work
    PushNotifications.addListener("registrationError", (error) => {
      alert("Error on registration: " + JSON.stringify(error));
    });

    // Show us the notification payload if the app is open on our device
    PushNotifications.addListener(
      "pushNotificationReceived",
      (notification) => {
        // setnotifications(notifications => [...notifications, { id: notification.id, title: notification.title, body: notification.body, type: 'foreground' }])
        console.log("pushNotificationReceived", notification);
        setShowBell(true);
        setNotification({
          title: notification.title,
          subtitle: notification.body,
        });
        // this.props.setNotification(notification.title, notification.body);
        // this.props.fetchChat(0);
      }
    );

    // Method called when tapping on a notification
    PushNotifications.addListener(
      "pushNotificationActionPerformed",
      (notification) => {
        // setnotifications(notifications => [...notifications, { id: notification.notification.data.id, title: notification.notification.data.title, body: notification.notification.data.body, type: 'action' }])
        window.location = "/notification";
      }
    );
  };

  useEffect(() => {
    if (isMobile) {
      registerMobileNotifications();
    } else if (!("Notification" in window)) {
      // Check if the browser supports notifications
      setPermStatus({ receive: "default" });
      alert("This browser does not support desktop notification");
    } else if (Notification.permission !== "granted") {
      setPermStatus({ receive: "denied" });
      setModal({
        state: true,
        type: "Success",
        isConfirm: false,
        message: constants?.pushPermissionMessage,
        onOkPressed: () => {
          initializeFirebase(
            (token) => {
              let deviceToken = getDeviceToken();
              if (!deviceToken && deviceToken !== token) {
                setDeviceToken(token);
                saveTokenFn.mutate(token);
              }
            },
            (notification) => {
              setShowBell(true);
              setNotification({
                title: notification.title,
                subtitle: notification.body,
              });
              //   this.props.fetchChat(0);
            },
            (message) =>
              setModal({
                state: true,
                type: "Error",
                isConfirm: false,
                message: message,
                onOkPressed: () => {},
              })
          );
        },
        onCancelPressed: () => {},
      });
    } else if (Notification.permission === "granted") {
      initializeFirebase(
        (token) => {
          let deviceToken = localStorage.getItem("deviceFCMToken"); //getDeviceToken();
          if (!deviceToken || deviceToken !== token) {
            setDeviceToken(token);
            saveTokenFn.mutate(token);
          }
        },
        (notification) => {
          setShowBell(true);
          setNotification({
            title: notification.title,
            subtitle: notification.body,
          });
          //   this.props.fetchChat(0);
        },
        (message) =>
          setModal({
            state: true,
            type: "Error",
            isConfirm: false,
            message: message,
            onOkPressed: () => {},
          })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div></div>;
};

export default NotificationService;
